import React from "react";
import * as i18nIsoCountries from "i18n-iso-countries";

i18nIsoCountries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

export const getPatientHomeAddress = (patient) => {
	if (!patient.home_country) return "";
	let country;
	if (patient.home_country?.length === 2) {
		country = `, ${i18nIsoCountries.getName(patient.home_country, "fr")}`;
	} else {
		country = patient.home_country ? `, ${patient.home_country}` : "";
	}

	return (
		<div>
			{patient.home_number || ""} {patient.home_street || ""} {patient.home_complement || ""} <br />
			{patient.home_postal_code || ""} {patient.home_city || ""} {country.replace(/ +(?= )/g, "").trim()}
		</div>
	);
};
